import TicketHttp from "../../ticketHttp";
import DownloadHttp from "../../downloadHttp";




class PaymentServices{
  
    static async getReports(params = {}) {

        console.log('params in getting reprts==', params);
        return TicketHttp.get('/payment/reports',  params );
    }
  

    static async getDetailReports(params = {}) {

        console.log('params in getting reprts==', params);
        return TicketHttp.get('/payment/detailReports',  params );
    }

    // static async getDetailReports1(params = {}) {

    //     console.log('params in getting reprts==', params);
    //     return TicketHttp.get('/payment/detailReports1',  params );
    // }

    static async getDetailReports1(params = {}) {
        // Remove undefined/null values from params
        const cleanParams = {};
        for (const key in params) {
            if (params[key] !== undefined && params[key] !== null && params[key] !== 'undefined') {
                cleanParams[key] = params[key];
            }
        }
        
        console.log('clean params in getting reports==', cleanParams);
        return TicketHttp.get('/payment/detailReports1', cleanParams);
    }

    
    static async getFullDetailReports(params = {}) {
        // Remove undefined/null values from params
        const cleanParams = {};
        for (const key in params) {
            if (params[key] !== undefined && params[key] !== null && params[key] !== 'undefined') {
                cleanParams[key] = params[key];
            }
        }
        
        console.log('clean params in getting reports==', cleanParams);
        return TicketHttp.get('/payment/getTodayFullReport', cleanParams);
    }


    static async getSingleFullReport(params = {}) {
        // Remove undefined/null values from params
        const cleanParams = {};
        for (const key in params) {
            if (params[key] !== undefined && params[key] !== null && params[key] !== 'undefined') {
                cleanParams[key] = params[key];
            }
        }
        
        console.log('clean params in getting reports==', cleanParams);
        return TicketHttp.get('/payment/getSingleFullReport', cleanParams);
    }

    


// Calling the phonepe after entering the data
    static async phonePePayment(data){
        return TicketHttp.post('/payment/pay', data);
    }

    static async createManualBooking(data) {

        console.log('createManualBooking reprts==', data);
        return TicketHttp.post('/payment/createManualBooking',  data );
    }

    // static async createManualBooking(data) {
    //     console.log('createManualBooking reprts==', data);
    //     const res = await TicketHttp.post('/payment/createManualBooking', data);
    //     console.log('response in http data', res); // ✅ Shows Axios full response
    //     return res.data; // ✅ FIX: return only the data
    //   }


    static async calculatePricing(data) {

        console.log('calculatePricing reprts==', data);
        return TicketHttp.post('/pricing/calculatePricing',  data );
    }

    static async calculatePricingV2(data) {
        console.log('calculatePricing v2==', data);
        return TicketHttp.post('/pricing/v2/calculate', data);
    }

    // Discounts
    static async validateCoupon(data) {
        return TicketHttp.post('/discounts/validate', data);
    }

    static async redeemCoupon(data) {
        return TicketHttp.post('/discounts/redeem', data);
    }

    static async confirmCoupon(data) {
        return TicketHttp.post('/discounts/confirm', data);
    }

    static async releaseCoupon(data) {
        return TicketHttp.post('/discounts/release', data);
    }

    
    static async sendTicket(data) {

        console.log('calculatePricing reprts==', data);
        return TicketHttp.post('/payment/sendTicket',  data );
    }

    static async validate(id){
        return TicketHttp.get(`/payment/validate/${id}`);
    }

    // Pricing Config
    static async getAvailableGateways(params = {}) {
        return TicketHttp.get('/pricing-config/available-gateways', params);
    }


  
   
    static async getRevenueReportWithSplit(theatreName = '') {
        const query = theatreName ? `?theatreName=${encodeURIComponent(theatreName)}` : '';
        // return TicketHttp.get(`/movies${query}`);

        console.log('**********Paymnet Split query****************', query)

        // console.log('params in getting reprts==', params);
        // return TicketHttp.get('/payment/getRevenueReportWithSplit',  params );
        return TicketHttp.get(`/payment/getRevenueReportWithSplit${query}`);
    }


    // For GST in the revenue getRevenueReportWithGSTSplit

    static async getRevenueReportWithGSTSplit(theatreName = '') {
        const query = theatreName ? `?theatreName=${encodeURIComponent(theatreName)}` : '';
        // return TicketHttp.get(`/movies${query}`);

        console.log('**********Paymnet Split query****************', query)

        // console.log('params in getting reprts==', params);
        // return TicketHttp.get('/payment/getRevenueReportWithSplit',  params );
        return TicketHttp.get(`/payment/getRevenueReportWithGSTSplit${query}`);
    }




    static async getTheatreAccounts() {

        // console.log('params in getting reprts==', params);
        return TicketHttp.get('/account/getTheatreAccounts');
    }

    static async updateTheatreAccount(id, data) {

        console.log('id and data', id, data);
        return TicketHttp.update(`/account/updateTheatreAccount/${id}`, data);
      }
      

    static async deleteTheatreAccount(id) {

        // console.log('params in getting reprts==', params);
        return TicketHttp.delete(`/account/deleteTheatreAccount/${id}`);
    }

    static async createTheatreAccounts(data) {

        console.log('dtaa', data);

        // console.log('params in getting reprts==', params);
        return TicketHttp.post('/account/createTheatreAccounts', data);
    }


    static async deleteBookingPermanently(id) {

        console.log('deleteBookingPermanently==', id);
        return TicketHttp.delete(`/bookings/deleteBookingById/${id}`);

      
    }



    static async validateBooking(bookingId) {

        console.log('deleteBookingPermanently==', bookingId);
        return TicketHttp.get(`/payment/validateBooking/${bookingId}`);

      
    }

         // for the refund of the success payments




         static async refundBooking(bookingId) {

            console.log('refundBooking==', bookingId);
            return TicketHttp.post(`/payment/refundBooking/${bookingId}`);
    
          
        }
    
    
        static async getRefundStatus(bookingId) {
    
            console.log('refundBooking==', bookingId);
            return TicketHttp.get(`/payment/refundStatus/${bookingId}`);
    
          
        }

        static async getDownloadInvoice(phoneNumber) {
            return DownloadHttp.downloadFile(`/payment/downloadInvoice/${phoneNumber}`);
          }


          
          
          
          



  
   
   
    
}
export default PaymentServices
